
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_5yalu_14",
  "code-editor": "awsui_code-editor_1gl9c_5yalu_14",
  "pane": "awsui_pane_1gl9c_5yalu_764",
  "pane__close-container": "awsui_pane__close-container_1gl9c_5yalu_775",
  "pane__list": "awsui_pane__list_1gl9c_5yalu_780",
  "pane__table": "awsui_pane__table_1gl9c_5yalu_787",
  "pane__item": "awsui_pane__item_1gl9c_5yalu_793",
  "pane__cell": "awsui_pane__cell_1gl9c_5yalu_793",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_5yalu_807",
  "pane__location": "awsui_pane__location_1gl9c_5yalu_828",
  "pane__description": "awsui_pane__description_1gl9c_5yalu_828",
  "focus-lock": "awsui_focus-lock_1gl9c_5yalu_843",
  "editor": "awsui_editor_1gl9c_5yalu_887",
  "editor-refresh": "awsui_editor-refresh_1gl9c_5yalu_917",
  "status-bar": "awsui_status-bar_1gl9c_5yalu_922",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_5yalu_931",
  "status-bar__left": "awsui_status-bar__left_1gl9c_5yalu_935",
  "status-bar__right": "awsui_status-bar__right_1gl9c_5yalu_942",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_5yalu_946",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_5yalu_946",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_5yalu_952",
  "tab-list": "awsui_tab-list_1gl9c_5yalu_957",
  "tab-button": "awsui_tab-button_1gl9c_5yalu_962",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_5yalu_995",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_5yalu_998",
  "tab-button--active": "awsui_tab-button--active_1gl9c_5yalu_1007",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_5yalu_1023",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_5yalu_1056",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_5yalu_1063",
  "count": "awsui_count_1gl9c_5yalu_1072",
  "text": "awsui_text_1gl9c_5yalu_1075",
  "loading-screen": "awsui_loading-screen_1gl9c_5yalu_1097",
  "error-screen": "awsui_error-screen_1gl9c_5yalu_1098"
};
  